module.exports = __webpack_public_path__ + "static/asa-logo-0f08bcf604cb02db60188e0568da9b5a.png";